import React from 'react';
import { BrowserRouter, Routes, Route} from 'react-router-dom';      

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './styles/main.scss'


import Navbar from './Components/Nav/Navbar';
import Footer from './Components/Footer/Footer';

import Home from './Pages/Home';
import EndSubscription from './Pages/EndSubscription';
import Error404 from './Pages/Error404';
import VideoPage from './Pages/VideoPage';
import ConditionsUtilisation from './Pages/ConditionsUtilisation';

function App() {
  return (
    <>
    <BrowserRouter> 
    <Navbar/>
        <Routes>
            <Route path="/" element={<Home />} /> 
            <Route path="/abonnement-exprire-6cl3MLBGRU8ZVPrclm899h2QG0tlj1Q5a1weuvTFjoH" element={<EndSubscription />} /> 
            <Route path="/video-explicative"  element={<VideoPage />} />
            <Route path="/conditions-utilisation"  element={<ConditionsUtilisation />} />
             <Route path='/*' element={ <Error404/> } />
        </Routes>
        <Footer/>  
    </BrowserRouter>

    </>
  );
}

export default App;
